<script>
import { HorizontalBar } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes';
import chartjsPluginDatalabels from 'chartjs-plugin-datalabels'
import { FINANCE_SUMMARY_LABELS, financeSummaryChartValues } from '../utils/finance-summary'

export default {
    name: 'HorizontalBarChart',
    extends: HorizontalBar,
    props: {
        summary: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chartData: {
                labels: FINANCE_SUMMARY_LABELS,
                datasets: [{
                  label: "金額",
                  data: financeSummaryChartValues(this.summary),
                  fill: true,
                  datalabels: {
                      formatter: (value) => {
                          return `${value.toLocaleString()}円`
                      },
                      anchor: 'center',
                      color: 'black'
                  }
                }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              legend: {
                display: true
              },
              plugins: {
                colorschemes: {
                  scheme: 'tableau.Orange20'
                },
                datalabels: {
                  font: {
                    weight: 'regular'
                  }
                }
              }
            }
        }
    },
    mounted: function() {
      this.addPlugin(chartjsPluginDatalabels);
      this.renderChart(this.chartData, this.options);
    }
}
</script>
